import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var STATE = Symbol('state');
var COMPONENT_WRAPPER = Symbol('componentWrapper');
export default {
  render: function render(_ref) {
    var _cache$COMPONENT_WRAP;

    var Component = _ref.component,
        cache = _ref.cache;
    (_cache$COMPONENT_WRAP = cache[COMPONENT_WRAPPER]) !== null && _cache$COMPONENT_WRAP !== void 0 ? _cache$COMPONENT_WRAP : cache[COMPONENT_WRAPPER] = /*#__PURE__*/function (_Component) {
      _inherits(ComponentWrapper, _Component);

      var _super = _createSuper(ComponentWrapper);

      function ComponentWrapper(props) {
        var _this;

        _classCallCheck(this, ComponentWrapper);

        _this = _super.call(this, props);

        if (cache[STATE]) {
          _this.state = cache[STATE];
        } else {
          cache[STATE] = _this.state;
        }

        return _this;
      }

      _createClass(ComponentWrapper, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (cache[STATE]) {
            this.componentDidUpdate();
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          _get(_getPrototypeOf(ComponentWrapper.prototype), "componentDidUpdate", this).call(this);

          cache[STATE] = this.state;
        }
      }]);

      return ComponentWrapper;
    }(Component);
    return {
      component: cache[COMPONENT_WRAPPER]
    };
  }
};